<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Cambiar destino de bins en tránsito</v-card-title>
      <v-card-text>
        <v-col cols="4">
          <v-text-field
              v-model="cambioSearch"
              append-icon="mdi-magnify"
              label="Escriba para filtrar despachos"
              single-line
              hide-details
          ></v-text-field>
        </v-col>
        <v-data-table 
          :headers="shippingsListHeaders"
          :items="shippingsListBody"
          class="elevation-1"
          no-data-text="No hay despachos"
          :search="cambioSearch"
        >
          <template v-slot:[`item.shipping_date`]="{item}">
            {{ formatDate(item.shipping_date )}}
          </template>
          <template v-slot:[`item.actions`]="{item}">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-icon
                  medium
                  class="mr-2"
                  @click="editShipping(item)"
                  v-on="on"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar Planta de destino o guía de despacho</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <!-- Modal cambiar destino -->
    <v-dialog
      v-model="dialog"
      width="600px"
    >
      <v-card>
        <v-card-title class="green darken-1">
          Elija nuevo destino para estos bins
        </v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-autocomplete
              v-model="shipping.facility"
              :items="facilities"
              :loading="isLoading"
              :search-input.sync="facilitySearch"
              color="white"
              hide-no-data
              hide-selected
              item-text="name"
              item-value="code"
              label="Planta de destino"
              placeholder="Escriba parte del nombre"
              prepend-icon="mdi-database-search"
              return-object
              persistent-hint
              clearable
            ></v-autocomplete>
            <v-text-field
              label="Guía de despacho"
              placeholder="Guía de despacho"
              v-model="shipping.waybill"
            >
            </v-text-field>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn
            @click="dialog = false"
          >Cancelar</v-btn>
          <v-btn
            color="primary"
            @click="updateShipping"
          >Realizar Cambios</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- / Modal -->

    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      snackbar: false,
      color: 'green',
      validation_message: '',
      cambioSearch: null,
      dialog: false,
      isLoading: false,
      company: null,
      companies: [],
      facilities: [],
      facilitySearch: null,
      shipping_date: new Date().toISOString().substr(0, 10),
      shippingIndex: -1,
      shipping: {
        id: 0,
        facility: {
          id: 0,
          code: ''
        },
        shift: {
          id: 0,
          name: ''
        },
        waybill: '',
        patent: '',
        shipping_date: new Date().toISOString().substr(0, 10),
      },
      shippingsListHeaders: [
        {
          text: 'Fecha',
          align: 'center',
          sortable: true,
          value: 'shipping_date',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'shift.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Planta Destino',
          align: 'center',
          sortable: true,
          value: 'facility.name',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patent',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Guia Despacho',
          align: 'center',
          sortable: true,
          value: 'waybill',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Certificado',
          align: 'center',
          sortable: true,
          value: 'certificate',
          class: "salmon black--text elevation-1 elevation-3"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "salmon black--text elevation-1 elevation-3"
        },
      ],
      shippingsListBody: [],
    }),
    mounted() {
      this.loadFacilities();
      this.loadCompanies();
      this.loadShippings();
    },
    methods:{
      async loadCompanies(){
        let url = `${this.base_url}companies`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.companies = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadFacilities(){
        let url = `${this.base_url}facilities`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.facilities = response.data.data;
        }).catch((error)=>{
            console.log(error);
        });
      },
      async loadShippings(){
        this.mostrarLoading('Cargando listado de despachos...');
        let url = `${this.base_url}shippings`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.shippingsListBody = response.data.data;
          this.ocultarLoading();
        }).catch((error)=>{
          console.log(error);
          this.ocultarLoading();
        });
      },
      async updateShipping(){
        let url = `${this.base_url}shippings/change/${this.shipping.id}`;
        let sendData = {
          'shipping':{
            'id': this.shipping.id,
            'facility_id': this.shipping.facility.id,
            'waybill': this.shipping.waybill
          }
        };
        let response = null;
        try{
          response = await this.axios.put(url, JSON.stringify(sendData), this.headers);
          let index = this.shippingsListBody.map(shipping => {
            return shipping.id;
          }).indexOf(this.shipping.id);
          this.shippingsListBody.splice(index, 1, response.data.data);
          this.dialog = false;
          this.showSnackBar(false);
        }catch(error){
          response = error.response;
          let msg = response.data.data;
          this.validation_message = response.status + ': ' + response.data.message + '. '+ msg;
          this.showSnackBar(true);
        }
      },
      editShipping(item) {
        this.shippingIndex = this.shippingsListBody.indexOf(item)
        this.shipping = Object.assign({}, item)
        this.dialog = true
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}-${month}-${year}`
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'headers'])
    },
    components:{
      
    }
  }
</script>